// ABOUTME: Accordion arrow icon component for expand/collapse indicators
// ABOUTME: Supports className, size, and color customization

interface AccordionArrowIconProps {
  className?: string
  size?: number
  color?: string
}

export const AccordionArrowIcon = ({ className = "", size = 12, color = "currentColor" }: AccordionArrowIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 6"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 5 5 1 1 5"
    />
  </svg>
)
